import { render, staticRenderFns } from "./MessageFooterIcon.vue?vue&type=template&id=ff124a3c&scoped=true&"
import script from "./MessageFooterIcon.vue?vue&type=script&lang=js&"
export * from "./MessageFooterIcon.vue?vue&type=script&lang=js&"
import style0 from "./MessageFooterIcon.vue?vue&type=style&index=0&id=ff124a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff124a3c",
  null
  
)

export default component.exports